module.exports = __webpack_public_path__ + "static/mite-6f4f7092a0d43c056925fd00a372d3e7.jpeg";